<template>
  <div class="content-area__heading">
    <vx-table
      :data="data"
      :columns="columns"
      :loading="loading"
      @sort="onSort(this.form[0].id_pessoa)"
    ></vx-table>
  </div>
</template>
<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import Axios from "axios";
import { moment } from "../../../helpers/utils";
export default {
  props: {
    id_empresa: Number,
    show_save: Boolean,
  },
  data: () => ({
    search: "",
    loading: false,
    loading_save: false,
    show_edit: false,
    title: "",
    form: [],
    show_update: false,
    id_empresa: 0,
    options: [
      {
        icone: "md-document",
        label: "Excluir",
        textColor: "#ff5252",
        show: true,
      },
    ],
    action: null,
    pagination: {
      page: 1,
      last_page: false,
    },
    data: [],
    columns: [],
  }),
  computed: {
    ...mapGetters(["currentUser"]),
  },
  methods: {
    // permission() {
    //   const permission = this.currentUser.permissao.filter((item) => {
    //     if (item.label == "Desenvolvimento" && item.value == "Clientes") {
    //       return item;
    //     }
    //   });
    //   return permission.length > 0;
    // },
    /**
     * Responsável carregar os dados
     */
    async getData() {
      this.loading = true;
      try {
        const id_pessoa = id_pessoa;
        const URI = `fiscal/nfe/notaPendente`;
        const { data } = await this.$axios.post(
          `${process.env.VUE_APP_CORE_API_V2}${URI}`,
          {
            id_empresa: this.$props.id_empresa,
            api_token: process.env.VUE_APP_CORE_API_V2_TOKEN,
          }
        );
        this.data = data;
      } catch (error) {
        console.warn(error);
      }
      this.loading = false;
    },
    /**
     * Responsável montar a estrutura da tabela
     */
    getColumns() {
      this.columns.push(
        {
          label: "Venda ",
          key: "id_movimento",
          order: "asc",
          sortable: true,
        },
        {
          label: "Data",
          key: "data_hora_registro",
          order: "asc",
          sortable: true,
        },
        {
          label: "Valor",
          key: "valor",
          order: "asc",
          sortable: true,
        },
        {
          label: "NFe",
          key: "nota_numero",
          order: "asc",
          sortable: true,
        },
        {
          label: " ",
          key: "options",
          render: (h, params) => {
            return h("VxOptions", {
              attrs: {
                id: params.row,
                onSelect: this.option,
                options: this.options,
              },
            });
          },
        }
      );
    },
    /**
     * Responsável abrir o registro para edição
     */
    onUpdate(id) {
      this.form = this.data.filter((item) => {
        return item.id_pessoa == id;
      });
      this.action = 0;
      this.title = `${id} - ${this.form[0].nome}`;
      this.show_edit = true;
    },
    /**
     * Responsável selecionar função adequada para a ação tomada pelo usuário
     */
    async option(dadosNota, label) {
      if (label == "Excluir") {
        this.$Modal.confirm({
          title: "Certeza que deseja excluir?",
          content: "Esta ação não poderá ser desfeita.",
          cancelText: "Não",
          okText: "Sim",
          onOk: () => {
            this.loading = true;
            this.loading_save = true;
            this.excluiNota(dadosNota);
          },
        });
      }
    },

    onSave(form) {
      let currentUserEmail = JSON.parse(localStorage.vuex).currentUser.email;
      let date = moment(form.period).format("YYYY-MM-DD");
      this.loading_save = true;
      this.show_update = false;
      this.updateDateActiveSystem(date, currentUserEmail);
      this.loading_save = false;
      this.show_edit = false;
    },
    /**
     * Responsável por capturar alterações nos formularios
     */
    onChange() {
      this.show_update = true;
    },
    /**
     * Responsável pela confirmação da ação
     */
    onConfirm(title, key, id) {
      return new Promise((resolve) => {
        this.$Modal.confirm({
          title: title,
          cancelText: "Não",
          okText: "Sim",
          onOk: () => {
            // reenviar e-mail
            if (key == 7) {
              this.sendEmail(id);
            }
            resolve();
          },
        });
      });
    },

    onSort() {
      this.getData();
    },
    /**
     * Responsável pela paginação dos registros quando alcança o fim da página
     */
    handleScroll: _.debounce(function (e) {
      const el = e.target.documentElement || e.target;
      let windowRelativeBottom = el.scrollHeight - el.offsetHeight;
      if (
        el.scrollTop > windowRelativeBottom - 50 &&
        this.pagination.current_page < this.pagination.last_page
      ) {
        this.pagination.page++;
        this.getData();
        el.scrollTop = windowRelativeBottom;
      }
    }, 1000),
    async getStatsData(data) {
      this.loading_save = true;

      let response = await Axios.get("clientes/stats", {
        params: {
          id: data.id_pessoa,
        },
      });

      if (response.data.stats !== 0) {
        this.form.push(response.data[0]);
      }

      this.loading_save = false;
    },
    async excluiNota(dadosNota) {
      this.loading = true;
      try {
        const id_fiscal = dadosNota.id_fiscal;
        const modelo_nf = dadosNota.modelo_nf;
        const URI = `fiscal/nfe?id_fiscal=${id_fiscal}&modelo_nf=${modelo_nf}&api_token=${process.env.VUE_APP_CORE_API_V2_TOKEN}&id_empresa=${dadosNota.id_empresa}`;
        await this.$axios.delete(`${process.env.VUE_APP_CORE_API_V2}${URI}`);
        let updateNotas = this.data.filter((value) => {
          return value.id_fiscal !== dadosNota.id_fiscal;
        });
        this.data = updateNotas;
        this.loading = false;
        this.$Message.success("Nota Excluida com sucesso!");
      } catch (error) {
        console.warn(error);
        this.$Message.error("Erro ao excluir nota!");
      }
      this.loading = false;
    },
  },
  watch: {
    search: _.debounce(function (e) {
      this.pagination.page = 0;
      this.getData();
    }, 500),
  },
  created() {
    // if (this.permission()) {
    //   this.options.push({
    //     icone: "md-bug",
    //     label: "Habilitar logs de Debug",
    //     textColor: "#000000",
    //   });
    // }
    this.getColumns();
    this.getData();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    let el = document.querySelector(".content-wrapper");
    if (el) {
      el.addEventListener("scroll", this.handleScroll);
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    let el = document.querySelector(".content-wrapper");
    if (el) {
      el.removeEventListener("scroll", this.handleScroll);
    }
  },
};
</script>
